module.exports = "https://cdn.realtymogul.com/static/media/img_location_slc.9ba5e29a.jpg";